import { initFaqSection } from "@/modules/section-faq";
import { initFooterSection } from "@/modules/section-footer";
import ready from "@/scripts/helpers/dom/ready";
import { Slicker } from '@rooi/slicker/esm2015/index';
import cookiePopup from "@/modules/popup-cookie";
import { headerFunctions } from "@/modules/section-header";


const slicker = new Slicker(document.querySelector('.js-slider'), {
  dots: false,
  arrows: false,
  infinite: true,
  speed: 6000,
	autoplaySpeed: 0,
  slidesToScroll: 1,
  centerMode: false,
  variableWidth: true,
  draggable: true,
  autoplay: true,
	swipeToSlide: true,
	pauseOnHover: false,
	fade: false,
	cssEase: 'linear',
	useTransform: false
});

const cards = document.querySelectorAll('.card');

if (cards) {
	console.log(cards);
  cards.forEach(card => {
    card.addEventListener('click', e => {
      if (card.hasAttribute('href')) {
        window.location.href = card.getAttribute('href');
      }
      else if (card.querySelector('.card__title-link')) {
        window.location.href = card.querySelector('.card__title-link').getAttribute('href');
      }
      else if (card.querySelector('.card__title-link')) {
        window.location.href = card.querySelector('.card__title-link').getAttribute('href');
      }
    });
  });
}

ready( () => {
  headerFunctions();
  initFaqSection();
  initFooterSection();
  setTimeout(() => {
    cookiePopup();
  }, 4000);
});